import styled from "styled-components"

export const TooltipContainer = styled.div`
  top: ${props => props.left ? props.left + "px" : ""};
  left: ${props => props.top ? props.top + "px" : ""};
  box-shadow: 0px 0px 10px 2.5px rgba(0, 0, 0, 0.1);
  background-color: #FFF;
  border-radius: 5px;
  position: absolute;
  width: 350px;
  z-index: 500;
`

export const Header = styled.div`
  background-color: ${props => props.tooltipColor ? props.tooltipColor : "#CDCDCD"}
`